import _slicedToArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import PropTypes from 'prop-types';
import * as React from 'react';
import { DropdownWithFloatingLabelContext } from './dropdown.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(source, excluded) {
  if (source == null) return {};

  var target = _object_without_properties_loose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /**
  * Whether or not to have the Dropdown expand to fill its container's width
  */
  fullWidth: PropTypes.bool
};
var DropdownWithFloatingLabel = renderWithRef('DropdownWithFloatingLabel', propTypes, function (props, ref) {
  var _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      children = props.children,
      rest = _object_without_properties(props, ["fullWidth", "children"]);

  var classNames = new Set(['swan-vanilla-ignore', 'swan-dropdown-with-floating-label']);
  if (fullWidth) classNames.add("swan-dropdown-with-floating-label-full-width");

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      dropdownId = _React$useState2[0],
      setDropdownId = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      dropdownElem = _React$useState4[0],
      setDropdownElem = _React$useState4[1];

  return /*#__PURE__*/React.createElement(DropdownWithFloatingLabelContext.Provider, {
    value: {
      dropdownId: dropdownId,
      setDropdownId: setDropdownId,
      dropdownElem: dropdownElem,
      setDropdownElem: setDropdownElem
    }
  }, /*#__PURE__*/React.createElement(RenderComp, {
    root: "div",
    forwardedRef: ref,
    props: rest,
    classNames: classNames
  }, children));
});
DropdownWithFloatingLabel.defaultProps = {
  fullWidth: false
};
export { DropdownWithFloatingLabel };